export interface IStockListSortChange {
  pageIndex: number;
  pageSize: number;
  sort: {
    key: string;
    value: string;
  }[];
}
